<nz-rate class="rate-display"
         [nzDisabled]="true"
         [ngModel]="rate"></nz-rate>
